import { render, staticRenderFns } from "./AppUserIcon.vue?vue&type=template&id=b9499d4c"
import script from "./AppUserIcon.vue?vue&type=script&lang=js"
export * from "./AppUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports